import React, { useEffect, useState } from 'react';
import { Box, Container, styled, Tab, Typography } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import palette from '../../theme/palette';
import useLocales from '../../hooks/useLocales';
import Withdraw from '../../layouts/dashboard/header/withdraw/Withdraw';
import Deposit from '../../layouts/dashboard/header/deposit/Deposit';
import { useSelector } from '../../redux/store';
import Image from '../../components/Image';
import { CardTitleAlt } from '../../layouts/GlobalStyles';

// STYLED COMPONENTS START

const TabContainer = styled(Container)(({ theme }) => ({
  padding: '0',
  maxWidth: 'unset !important',
  background: 'linear-gradient(0deg, rgb(7, 20, 44) -5.86%, rgb(38, 58, 89) 104.05%)',
  minHeight: '100%',
  paddingTop: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    background: 'unset',
    paddingTop: 0,
  },
}));

const ParentContainer = styled(Container)(({ theme }) => ({
  maxWidth: '1370px',
  width: '100%',
  margin: '0 auto',
  padding: '10px 10px 20px 10px',
}));

const StyledTabList = styled(TabList)(() => ({
  background: palette.transactionDialog.tab.bg,
  minHeight: 'unset',
  padding: 5,
  borderRadius: 5,
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
}));

const StyledTab = styled(Tab)(() => ({
  minHeight: 'unset',
  padding: '10px',
  fontSize: '20px',
  borderRadius: '5px',
  fontWeight: 600,
  display: 'flex',
  flex: 1,
  margin: '0!important',
}));
// STYLED COMPONENTS END

const Wallet = () => {
  // LANGUAGE TRANSLATION
  const { translate } = useLocales();

  const { isOpenTransactionsDialog } = useSelector((x) => x.transactionsDialog);

  const [activeTab, setActiveTab] = useState('DEPOSIT');

  useEffect(() => {
    if (isOpenTransactionsDialog?.isDeposit) {
      setActiveTab('DEPOSIT');
    } else {
      setActiveTab('WITHDRAW');
    }
  }, [isOpenTransactionsDialog]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    // <Page title="Wallet">
    <TabContainer>
      {/* HEADER TITLE DESKTOP */}
      <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 2, mb: 1, alignItems: 'center', pt: '10px', pl: '10px' }}>
        <Box
          sx={{
            background: 'linear-gradient(360deg, rgba(21, 23, 29, 0.6) -5.86%, rgba(58, 60, 64, 0.6) 104.05%)',
            borderRadius: '10px',
            width: '55px',
            height: '55px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {activeTab === 'DEPOSIT' ? (
            <Image src={require('../../assets/mobile-menu/deposit.png')} sx={{ width: '32px', height: '32px' }} />
          ) : (
            <Image src={require('../../assets/mobile-menu/withdraw.png')} sx={{ width: '32px', height: '32px' }} />
          )}
        </Box>

        <Typography sx={{ fontWeight: 700, fontSize: '1.5rem' }}>
          {translate(activeTab === 'DEPOSIT' ? 'deposit' : 'withdraw')}
        </Typography>
      </Box>
      {/* HEADER TITLE MOBILE */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          display: { xs: 'flex', sm: 'none' },
          justifyContent: 'center',
          top: 0,
        }}
      >
        <CardTitleAlt>{translate(activeTab === 'DEPOSIT' ? 'deposit' : 'withdraw')}</CardTitleAlt>
      </Box>

      <TabContext value={activeTab}>
        {/* <ParentContainer maxWidth="lg">
            <StyledTabList
              onChange={handleChange}
              variant="fullWidth"
              TabInditorProps={{
                style: { display: 'none!important' },
              }}
              sx={{
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              <StyledTab
                label={translate('deposit')}
                value="DEPOSIT"
                sx={{
                  background:
                    activeTab === 'DEPOSIT'
                      ? palette.transactionDialog.tab.active
                      : palette.transactionDialog.tab.inactive,
                  color:
                    activeTab === 'DEPOSIT'
                      ? `${palette.transactionDialog.tab.activeTxt} !important`
                      : palette.transactionDialog.tab.inactiveTxt,
                }}
              />
              <StyledTab
                label={translate('withdraw')}
                value="WITHDRAW"
                sx={{
                  background:
                    activeTab === 'WITHDRAW'
                      ? palette.transactionDialog.tab.active
                      : palette.transactionDialog.tab.inactive,
                  color:
                    activeTab === 'WITHDRAW'
                      ? `${palette.transactionDialog.tab.activeTxt} !important`
                      : palette.transactionDialog.tab.inactiveTxt,
                }}
              />
            </StyledTabList>
          </ParentContainer>
          <Divider orientation="horizontal" flexItem sx={{ borderWidth: '1px', borderColor: 'rgba(255,255,255,0.5)', my: 2 }} /> */}
        <ParentContainer>
          <TabPanel value="DEPOSIT">
            <Deposit />
          </TabPanel>
          <TabPanel value="WITHDRAW">
            <Withdraw />
          </TabPanel>
        </ParentContainer>
      </TabContext>
    </TabContainer>

    // </Page>
  );
};

export default Wallet;
